import { useRef } from "react";
import classNames from "classnames";

import LockerCardCarrierBadge from "@components/Lockers/LockerCard/LockerCardCarrierBadge";
import LockerCardInactiveTag from "@components/Lockers/LockerCard/LockerCardInactiveTag";
import LockerCardSchedule from "@components/Lockers/LockerCard/LockerCardSchedule";
import useSlidingWindow from "@lib/useSlidingWindow";
import LockerCardName from "@components/Lockers/LockerCard/LockerCardName";
import LockerCardAddress from "@components/Lockers/LockerCard/LockerCardAddress";

const PAGE_SIZE = 30;
const OVERLAP = 5; // number of items to overlap between pages for smoother scrolling

const LockerList = ({ data, onLockerSelect }) => {
  const scrollContainerRef = useRef(null);

  const {
    visibleItems,
    topObserverRef,
    bottomObserverRef,
    canLoadMoreUp,
    canLoadMoreDown,
    setItemRef,
  } = useSlidingWindow({
    data,
    scrollContainerRef,
    pageSize: PAGE_SIZE,
    overlap: OVERLAP,
  });

  return (
    <ul
      ref={scrollContainerRef}
      className="flex-1 overflow-y-auto min-h-0 max-h-[50vh] scrollbar-none"
    >
      {canLoadMoreUp && (
        <div ref={topObserverRef} id="top-loader" className="h-[1px]" />
      )}

      {visibleItems.map((locker, index) => (
        <li
          key={locker.id}
          className={classNames(
            "py-[12px]  hover:bg-[#EEF9FE] cursor-pointer",
            {
              "border-b border-[#E6E6E6]": index < data.length - 1,
            }
          )}
          onClick={() => onLockerSelect({ marker: locker })}
          ref={setItemRef(locker.id)}
        >
          <div className="mb-[8px] flex flex-wrap items-center gap-[8px]">
            <LockerCardCarrierBadge locker={locker} />

            <LockerCardInactiveTag locker={locker} />
          </div>

          <LockerCardName locker={locker} />
          <LockerCardAddress locker={locker} />

          <LockerCardSchedule />
        </li>
      ))}

      {canLoadMoreDown && (
        <div ref={bottomObserverRef} id="bottom-loader" className="h-[1px]" />
      )}
    </ul>
  );
};

export default LockerList;
